module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-auth-confirm-page"
  }, [_c('mobile-header', {
    attrs: {
      "theme": "light",
      "show-menu": false
    }
  }), _vm._v(" "), (!_vm.loading) ? [(true) ? _c('div', {
    staticClass: "d-flex flex-column",
    staticStyle: {
      "align-items": "center",
      "height": "90vh"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "d-flex flex-column",
    staticStyle: {
      "gap": "20px",
      "align-items": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "110px"
    },
    attrs: {
      "src": "/static/images/lined_check.svg"
    }
  }), _vm._v(" "), _c('div', [_c('center', {
    staticStyle: {
      "font-weight": "800",
      "font-size": "24px"
    }
  }, [_vm._v("\n              Email confirmed!\n            ")]), _vm._v(" "), _c('center', {
    staticStyle: {
      "font-weight": "500",
      "font-size": "20px"
    }
  }, [_vm._v("Your account has been activated")])], 1)])]), _vm._v(" "), _vm._m(1)]) : _c('div', {
    staticClass: "section"
  }, [_c('h3', [_vm._v("Check your email")])])] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "logo",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "src": "/static/images/nav_logo_primary.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-bottom": "-130px"
    }
  }, [_c('button', {
    staticStyle: {
      "background-color": "black",
      "width": "300px",
      "padding": "15px 5px",
      "border-radius": "25px",
      "color": "white",
      "font-size": "18px"
    }
  }, [_c('a', {
    staticStyle: {
      "all": "unset"
    },
    attrs: {
      "href": "ys://login"
    }
  }, [_vm._v("Open App")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d10e088c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/auth/confirmation.vue
// module id = 1853
// module chunks = 180